import { render, staticRenderFns } from "./check-code.vue?vue&type=template&id=1ee71bf1&scoped=true&"
import script from "./check-code.vue?vue&type=script&lang=js&"
export * from "./check-code.vue?vue&type=script&lang=js&"
import style0 from "./check-code.vue?vue&type=style&index=0&id=1ee71bf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee71bf1",
  null
  
)

export default component.exports